import { render, staticRenderFns } from "./ed-modal.vue?vue&type=template&id=d70c38ca"
import script from "./ed-modal.vue?vue&type=script&lang=js"
export * from "./ed-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports